import React from "react";
import { Link } from "gatsby";
import MobileNavigationLink from "./MobileNavigationLink";
import resolveLink from "src/utils/resolveLink";
import GetCareers from "src/utils/GetCareers"

const MobileNavigationItem = (item) => {
  return (
    <div className="border-b border-gray-800">
      {item.navigation_sections.length > 0 && (
        <>
          <button
            className="font-display flex w-full items-center py-3 text-xl uppercase text-white focus:outline-none"
            onClick={() => item.handleNavItemClick(item._uid)}
          >
            {item.label}
            <i className="fal fa-angle-right ml-auto -mt-px"></i>
          </button>
          <div
            className={`z-10 fixed top-[64px] h-[calc(100vh-64px)] w-screen overflow-y-scroll bg-gray-100 px-6 pt-8 pb-16 transition-all duration-300 ${
              item.open ? "left-0" : "-left-full"
            }`}
          >
            <div className="border-t border-gray-300">
              <button
                className="text-red font-display flex w-full items-center border-b border-gray-300 py-3 text-xl uppercase focus:outline-none"
                onClick={() => item.handleNavItemClick(item._uid)}
              >
                <i className="fal fa-angle-left -mt-px mr-2"></i>
                {item.label}
              </button>
              {item.top_level_label && (
                <Link
                  to={resolveLink(`/${item.top_level_link.cached_url}`)}
                  className="text-blue font-display flex w-full items-center border-b border-gray-300 py-3 text-xl uppercase"
                >
                  {item.top_level_label}
                </Link>
              )}
              {item.navigation_sections.map((section, index) => (
                <MobileNavigationLink
                  {...section}
                  handleNavLinkClick={item.handleNavLinkClick}
                  key={index}
                />
              ))}
            </div>
          </div>
        </>
      )}
      {item.navigation_sections.length === 0 && (
        <Link
          to={resolveLink(`/${item.target.cached_url}`)}
          className="font-display flex w-full items-center py-3 text-xl uppercase text-white"
        >
          <div className="relative">
            {item.label}
            {item.careers_number &&
              <div className="absolute -top-1 -right-5 bg-red h-4 w-4 flex justify-center items-center text-white text-xs rounded-full">
                <span className="mt-px">
                  {GetCareers('')?.length}
                </span>
              </div>
            }
          </div>
        </Link>
      )}
    </div>
  );
};

export default MobileNavigationItem;
